import React from "react";

function Disabled() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#e94444"
        d="M256 0C114.613 0 0 114.613 0 256s114.613 256 256 256 256-114.613 256-256S397.387 0 256 0zM93.539 356.87a188.142 188.142 0 01-7.248-12.742c-12.886-24.73-20.517-52.578-21.425-82.139-3.335-108.18 84.7-198.198 192.922-197.207 31.131.279 60.476 8.013 86.373 21.477a188.331 188.331 0 0112.731 7.269c1.879 1.167 2.189 3.779.63 5.338L98.887 357.5c-1.559 1.559-4.171 1.249-5.348-.63zM256 447.228c-31.792 0-61.767-7.765-88.128-21.487a193.35 193.35 0 01-12.752-7.259c-1.89-1.177-2.199-3.789-.64-5.349L413.133 154.48c1.559-1.559 4.172-1.249 5.349.64a193.804 193.804 0 017.259 12.752c13.723 26.392 21.487 56.336 21.487 88.128 0 105.609-85.588 191.228-191.228 191.228z"
        data-original="#e94444"
      ></path>
      <path
        fill="#d83131"
        d="M402.426 45.99c56.243 46.95 92.021 117.587 92.021 196.587 0 141.387-114.613 256-256 256-54.446 0-104.938-17.006-146.426-45.99C136.431 489.687 193.613 512 256 512c141.387 0 256-114.613 256-256 0-86.93-43.326-163.742-109.574-210.01z"
        data-original="#d83131"
      ></path>
    </svg>
  );
}

export default Disabled;
